import * as React from 'react'
import './styles.scss'

const PinIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="40"
      viewBox="14 10 21 20"
    >
      <g fill='#194883' transform="translate(-1605 -7403)">
        <rect className="a" width="50" height="40" transform="translate(1605 7403)" />
        <path
          d="M17.3,3a9.793,9.793,0,0,0-9.8,9.8c0,7.35,9.8,18.2,9.8,18.2s9.8-10.85,9.8-18.2A9.793,9.793,0,0,0,17.3,3Zm0,13.3a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,17.3,16.3Z"
          transform="translate(1612.7 7406)" />
      </g>
    </svg>
  )
}

export default PinIcon
